// src/i18n/en/activityMonitorAdditional.ts

export const activityMonitorAdditional = {
  actions: {
    viewJourney: 'View complete journey',
  },
  sessionStatus: {
    error: 'Error',
  },
  eventStatus: {
    error: 'Event with error',
  },
  messages: {
    noEvents: 'No events recorded',
    moreEvents: 'more events',
  },
};

export default activityMonitorAdditional;
